import { EcommerceAPIApi as EcommerceApi, Theme } from '@parkingbase/ecommerce-api-test';
import type { RawAxiosRequestConfig } from 'axios';
import { BaseApiService } from './baseApi.service';

export class ThemeService extends BaseApiService {
  protected themeApi: EcommerceApi;
  constructor() {
    super();
    this.themeApi = new EcommerceApi(this.apiConfig, undefined, this.apiClient);
  }

  async getDefaultTheme(options?: RawAxiosRequestConfig) {
    const response = await this.themeApi.defaultTheme({ skipAuth: true, ...options } as any);
    return response.data;
  }

  async getConvergeWebsiteThemes(): Promise<Record<string, Theme>> {
    const response = await this.themeApi.getConvergeWebsiteThemes();
    const data = response.data;
    if (typeof data === 'string') {
      return JSON.parse(data) as Record<string, Theme>;
    }
    return (data as unknown as Record<string, Theme>) ?? {};
  }
}
